import { DialogContent, DialogHeader } from "@/src/components/ui/dialog";
import { Dialog } from "@radix-ui/react-dialog";
import { useState } from "react";
import { YachtLabel } from "./model";
import { FactoryDialogProps } from "@/src/lib/useFactoryDialog";
import { FormControl, FormItem, FormLabel } from "@/src/components/ui/form";
import { Input } from "@/src/components/ui/input";
import { Button } from "@/src/components/ui/button";
import { useFetch } from "@/src/lib/useFetch";

export type AddLabelDialogProps = FactoryDialogProps<YachtLabel>;
export function AddLabelDialog(props: AddLabelDialogProps) {
  const [value, setValue] = useState("");

  const { fetch, isFetching } = useFetch();

  const createLabel = () =>
    props.onDone(fetch<{ data: YachtLabel }>("/api/yachts/labels", "POST", { value }).then((r) => r.data));

  return (
    <Dialog
      onOpenChange={(v) => {
        if (!v) {
          props.onDone(Promise.resolve(null));
        }
      }}
      open={props.open}
    >
      <DialogContent>
        <DialogHeader>
          <h2 className="text-3xl">Add label</h2>
        </DialogHeader>
        <FormItem required>
          <FormLabel>Label name</FormLabel>
          <FormControl>
            <Input value={value} onChange={(e) => setValue(e.currentTarget.value)} />
          </FormControl>
        </FormItem>
        <Button disabled={isFetching} onClick={() => createLabel()}>
          Add
        </Button>
      </DialogContent>
    </Dialog>
  );
}
